import { API_URL } from '../config/connect';

const getAdminAnnouncementById = async (id) => {
    const googleIdToken = localStorage.getItem("google_id_token");

    if (!googleIdToken) {
        throw new Error("No token found. User is not signed in.");
    }

    try {
        const response = await fetch(`${API_URL}/api/v1/admin/announcement/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${googleIdToken}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching announcement:', error);
        throw error;
    }
};

export default getAdminAnnouncementById;

